import React, { useEffect, useState } from 'react';
import { Card, Button } from 'reactstrap';
import { CSVLink } from "react-csv";
import moment from 'moment';

import IntlMessages from '../../../../../../helpers/IntlMessages';
import { AreaChart } from '../../charts';
import { ThemeColors } from '../../../../../../helpers/ThemeColors';
const colors = ThemeColors();

const ConversationHourlyChartCard = ({
  conversationHourly
}) => {
  const chattimeDatasets = conversationHourly.length > 0 ? conversationHourly.map(elem => elem.count) : [];
  const labels = conversationHourly.length > 0 ? conversationHourly.map(
    elem => elem.timing
  ) : [];
  const areaChartData = {
    labels,
    datasets: [
      {
        label: 'Conversations',
        data: chattimeDatasets,
        borderColor: colors.themeColor1,
        pointBackgroundColor: colors.foregroundColor,
        pointBorderColor: colors.themeColor1,
        pointHoverBackgroundColor: colors.themeColor1,
        pointHoverBorderColor: colors.foregroundColor,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        fill: false,
        borderWidth: 2,
        backgroundColor: colors.themeColor1_10,
      },
    ],
  };

  return (
    <Card className="dashboard-filled-line-chart" style={{ height: 460 }}>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">

              <span>Hourly Conversation</span>
              {/* <IntlMessages id="dashboards.engagement-time" /> */}
            </h5>
            <span className="text-muted text-small d-block">
              <span>Hourly Conversation</span>
            </span>
          </div>
        </div>
      </div>

      <div className="chart card-body pt-0">
        <AreaChart shadow data={areaChartData} />
      </div>
    </Card>
  );
};

export default ConversationHourlyChartCard;
